export function isLayerSpec(spec) {
    return 'layer' in spec;
}
